import {
  CommonIncidentId,
  VolleyballIncidentId,
} from '@collector/sportsapi-client-legacy'

import { HistoryFiltersConfig } from '../../configuration'
import { historyFiltersAttributesConfig } from './historyFiltersAttributesConfig'

export const historyFiltersConfig: HistoryFiltersConfig = {
  historyFiltersAttributes: historyFiltersAttributesConfig,
  historyFiltersIncidents: [
    VolleyballIncidentId.ServiceAce,
    VolleyballIncidentId.ServiceError,
    VolleyballIncidentId.AttackPoint,
    VolleyballIncidentId.AttackError,
    VolleyballIncidentId.BlockPoint,
    VolleyballIncidentId.TechnicalErrors,
    VolleyballIncidentId.Point,
    VolleyballIncidentId.Serve,
    VolleyballIncidentId.NeutralAttack,
    VolleyballIncidentId.Dig,
    VolleyballIncidentId.Set,
    VolleyballIncidentId.Cards,
    VolleyballIncidentId.Challenge,
    VolleyballIncidentId.RefereeChallenge,
    VolleyballIncidentId.Timeout,
    VolleyballIncidentId.TimeoutOver,
    VolleyballIncidentId.Reception,
    CommonIncidentId.Betstop,
    CommonIncidentId.Betstart,
    CommonIncidentId.TechnicalProblems,
    VolleyballIncidentId.BreakDuringTheGame,
    CommonIncidentId.MatchResumed,
    VolleyballIncidentId.RepeatAction,
    VolleyballIncidentId.PlayerChangeSides,
    VolleyballIncidentId.InPossession,
    VolleyballIncidentId.SetBall,
    VolleyballIncidentId.MatchBall,
  ],
}
